<template>
  <div
    class="group-item ml-4"
    :class="{ 'is-dragging': isDragging && isAdmin }"
    :draggable="isAdmin"
    @dragstart="handleDragStart"
    @dragend="handleDragEnd"
    @contextmenu.prevent.stop="handleContextMenu"
  >
    <router-link
      v-slot="{ href, isActive, navigate }"
      :to="itemRoute"
      custom
    >
      <li
        class="font-medium h-7 my-1 hover:bg-slate-25 hover:text-bg-50 flex items-center px-2 rounded-md dark:hover:bg-slate-800"
        :class="{ 'bg-woot-25 dark:bg-slate-800': isActive }"
        @click="navigate"
      >
        <a
          :href="href"
          class="inline-flex text-left max-w-full w-full items-center"
        >
          <span
            v-if="itemType === 'label'"
            class="inline-flex rounded-sm bg-slate-100 h-3 w-3.5 mr-1.5 rtl:mr-0 rtl:ml-1.5 border border-slate-50 dark:border-slate-900 flex-shrink-0"
            :style="{ backgroundColor: item.color }"
          />
          <span v-else class="inline-flex items-center justify-center w-4 rounded-sm p-0.5 mr-1.5 rtl:mr-0 rtl:ml-1.5">
            <fluent-icon
              class="text-xxs"
              :class="iconClasses(isActive)"
              :icon="computedIcon"
              size="12"
            />
          </span>
          <div class="items-center flex overflow-hidden whitespace-nowrap text-ellipsis w-full justify-between">
            <span
              :title="itemName"
              :class="textClasses(isActive)"
            >
              {{ itemName }}
            </span>
          </div>
        </a>
      </li>
    </router-link>
  </div>
</template>

<script>
import { frontendURL } from 'dashboard/helper/URLHelper';
import adminMixin from 'dashboard/mixins/isAdmin';
import { getInboxClassByType } from 'dashboard/helper/inbox';

export default {
  name: 'GroupItem',
  mixins: [adminMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    itemType: {
      type: String,
      required: true,
      validator: value => ['team', 'inbox', 'label'].includes(value)
    },
    groupId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      isDragging: false,
    };
  },
  computed: {
    computedIcon() {
      if (this.itemType === 'team') {
        return 'people-team';
      }
      return getInboxClassByType(this.item.channel_type, this.item.phone_number);
    },
    itemName() {
      return this.itemType === 'label' ? this.item.title : this.item.name;
    },
    itemRoute() {
      const accountId = this.$store.getters.getCurrentAccountId;
      if (this.itemType === 'label') {
        return frontendURL(`accounts/${accountId}/label/${this.item.title}`);
      }
      return this.itemType === 'team' 
        ? frontendURL(`accounts/${accountId}/team/${this.item.id}`)
        : frontendURL(`accounts/${accountId}/inbox/${this.item.id}`);
    }
  },
  methods: {
    iconClasses(isActive) {
      return {
        'text-woot-500 dark:text-woot-500': isActive,
        'text-slate-700 dark:text-slate-200': !isActive
      };
    },
    textClasses(isActive) {
      return {
        'text-woot-500 dark:text-woot-500': isActive,
        'text-slate-700 dark:text-slate-100': !isActive,
        'text-ellipsis overflow-hidden whitespace-nowrap max-w-full': true
      };
    },
    handleDragStart(e) {
      if (!this.isAdmin) return;
      
      this.isDragging = true;
      e.dataTransfer.setData('text/plain', JSON.stringify({
        type: 'item',
        id: this.item.id,
        itemType: this.itemType,
        sourceGroupId: this.groupId
      }));
    },
    handleDragEnd() {
      this.isDragging = false;
    },
    handleContextMenu(event) {
      this.$emit('show-context-menu', event, { 
        itemType: this.itemType, 
        itemId: this.item.id 
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.group-item {
  &.is-dragging {
    opacity: 0.5;
  }
}
</style>
